import React, {ReactNode} from "react";

export function SectionWrapper({children}: {children: ReactNode}) {
    return (
        <div className="section-wrapper">
            <div className="section">{children}</div>
        </div>
    );
}
